

















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
    components: {},
})
export default class PortfolioList extends Vue {
    @Prop() userUid!: string;
    private portfolios: any = "";

    async mounted() {
        // this.portfolios = await this.$api.portfolioList(this.userUid);
        // console.log(this.portfolios);
    }

}
